// main menu icon
import Dashboard from "@/assets/images/layouts/sideBar/mainMenu/dashboard.svg";
import Chart from "@/assets/images/layouts/sideBar/mainMenu/kibot_chart.svg";
import Auto from "@/assets/images/layouts/sideBar/mainMenu/kibot_auto.svg";
import Demo from "@/assets/images/layouts/sideBar/mainMenu/demo.svg";
import Explorer from "@/assets/images/icons/chart/dark/strategy_chart_ico.svg";

// import Wallet              from '@/assets/images/layouts/sideBar/mainMenu/my_wallet.svg'
// import DailyInfo           from '@/assets/images/layouts/sideBar/mainMenu/daily_info.svg'
// import Invite              from '@/assets/images/layouts/sideBar/mainMenu/invite_friends.svg'
// import Price               from '@/assets/images/layouts/sideBar/mainMenu/price.svg'
// // import Gift                from '@/assets/images/layouts/sideBar/mainMenu/gift_plaza.svg'
// import Profit              from '@/assets/images/layouts/sideBar/mainMenu/profit_status.svg'
// import Partnership         from '@/assets/images/layouts/sideBar/mainMenu/partnership.svg'
// import About               from '@/assets/images/layouts/sideBar/mainMenu/about.svg'
// import Event               from '@/assets/images/layouts/sideBar/mainMenu/event.svg'
// import Support             from '@/assets/images/layouts/sideBar/mainMenu/support.svg'
// import Inquiry             from '@/assets/images/layouts/sideBar/mainMenu/inquiry.svg'

// checked main menu icon
import DashboardActive from "@/assets/images/layouts/sideBar/mainMenu/dashboard_active.svg";
import ChartActive from "@/assets/images/layouts/sideBar/mainMenu/chart_active.svg";
import AutoActive from "@/assets/images/layouts/sideBar/mainMenu/kibot_auto_active.svg";
import DemoActive from "@/assets/images/layouts/sideBar/mainMenu/demo_active.svg";
// import WalletActive        from '@/assets/images/layouts/sideBar/mainMenu/my_wallet_active.svg'
// import DailyInfoActive     from '@/assets/images/layouts/sideBar/mainMenu/daily_info_active.svg'
// import InviteActive        from '@/assets/images/layouts/sideBar/mainMenu/invite_friends_active.svg'
// import PriceActive         from '@/assets/images/layouts/sideBar/mainMenu/price_active.svg'
// // import GiftActive          from '@/assets/images/layouts/sideBar/mainMenu/gift_plaza_active.svg'
// import ProfitActive        from '@/assets/images/layouts/sideBar/mainMenu/profit_status_active.svg'
// import PartnershipActive   from '@/assets/images/layouts/sideBar/mainMenu/partnership_active.svg'
// import AboutActive         from '@/assets/images/layouts/sideBar/mainMenu/about_active.svg'
// import EventActive         from '@/assets/images/layouts/sideBar/mainMenu/event_active.svg'
// import SupportActive       from '@/assets/images/layouts/sideBar/mainMenu/support_active.svg'

// sub menu icon
import Alarm from "@/assets/images/layouts/sideBar/mainMenu/alarm.svg";
import Dominance from "@/assets/images/layouts/sideBar/mainMenu/dominance.svg";
// import Bubble from "@/assets/images/layouts/sideBar/mainMenu/bubble.svg";
import After from "@/assets/images/layouts/sideBar/mainMenu/after.svg";
import CoinList from "@/assets/images/layouts/sideBar/mainMenu/coin_list.svg";
// import Cue                 from '@/assets/images/layouts/sideBar/mainMenu/cue.svg'
import Score from "@/assets/images/layouts/sideBar/mainMenu/score.svg";
import Meta from "@/assets/images/layouts/sideBar/mainMenu/meta.svg";
import TradingView from "@/assets/images/layouts/sideBar/mainMenu/trading_view.svg";
import Favorites from "@/assets/images/layouts/sideBar/mainMenu/favorites.svg";

// bot
import Position from "@/assets/images/layouts/sideBar/mainMenu/position_bot.svg";
// import Dca from "@/assets/images/layouts/sideBar/mainMenu/dca_bot.svg";
// import FullAuto from "@/assets/images/layouts/sideBar/mainMenu/full_auto_bot.svg";
import Grid from "@/assets/images/layouts/sideBar/mainMenu/grid_bot.svg";
import PositionActive from "@/assets/images/layouts/sideBar/mainMenu/positionActive.svg";
// import DcaActive from "@/assets/images/layouts/sideBar/mainMenu/dcaActive.png";
// import FullAutoActive from "@/assets/images/layouts/sideBar/mainMenu/fullAutoActive.png";
import GridActive from "@/assets/images/layouts/sideBar/mainMenu/gridActive.svg";
// import DailyBriefing       from '@/assets/images/layouts/sideBar/mainMenu/daily_briefing.svg'
// import Pick                from '@/assets/images/layouts/sideBar/mainMenu/kibot_pick.svg'
// import Feed                from '@/assets/images/layouts/sideBar/mainMenu/feed.svg'
// import ROI                 from '@/assets/images/layouts/sideBar/mainMenu/ROI.svg'
// import Status              from '@/assets/images/layouts/sideBar/mainMenu/status.svg'
// import AboutUs             from '@/assets/images/layouts/sideBar/mainMenu/about_us.svg'
// import BrandStory          from '@/assets/images/layouts/sideBar/mainMenu/brand_story.svg'
// import Media               from '@/assets/images/layouts/sideBar/mainMenu/media.svg'
// import Notice              from '@/assets/images/layouts/sideBar/mainMenu/notice.svg'

// // checked sub menu icon
// import DailyBriefingActive from '@/assets/images/layouts/sideBar/mainMenu/daily_briefing_active.svg'
// import PickActive          from '@/assets/images/layouts/sideBar/mainMenu/kibot_pick_active.svg'
// import FeedActive          from '@/assets/images/layouts/sideBar/mainMenu/feed_active.svg'
// import ROIActive           from '@/assets/images/layouts/sideBar/mainMenu/ROI_active.svg'
// import StatusActive        from '@/assets/images/layouts/sideBar/mainMenu/status_active.svg'
// import AboutUsActive       from '@/assets/images/layouts/sideBar/mainMenu/about_us_active.svg'
// import BrandStoryActive    from '@/assets/images/layouts/sideBar/mainMenu/brand_story_active.svg'
// import MediaActive         from '@/assets/images/layouts/sideBar/mainMenu/media_active.svg'
// import NoticeActive        from '@/assets/images/layouts/sideBar/mainMenu/notice_active.svg'

// // setting menu icon
import Store from "@/assets/images/layouts/sideBar/settingMenu/store.svg";
import Settings from "@/assets/images/layouts/sideBar/settingMenu/settings.svg";
import Mode from "@/assets/images/layouts/sideBar/settingMenu/mode.svg";
import StoreActive from "@/assets/images/layouts/sideBar/settingMenu/storeActive.svg";
import SettingsActive from "@/assets/images/layouts/sideBar/settingMenu/settingsActive.svg";
import ModeActive from "@/assets/images/layouts/sideBar/settingMenu/modeActive.svg";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
let txn_no = cookies.get("X_TXN_NO");
const currentEnv = process.env.NODE_ENV;
// console.log("currentEnv", currentEnv, "txn_no", txn_no);

function setEnv() {
  if (currentEnv == "production") {
    return true;
    // if(txn_no == '88' || txn_no == 88 || txn_no == '106' || txn_no == 106){
    //     return true;
    // }else {
    //     return true;
    // }
  } else {
    return true;
  }
}
export default {
  namespaced: true,
  state: () => ({
    isFold: false,
    menuList: [
      // {
      //     key           : "dashboard",
      //     label         : "Dashboard",
      //     icon          : Dashboard,
      //     activeIcon    : DashboardActive,
      //     route         : "/DashBoard",
      //     foldMenuRoute : "/DashBoard",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : true,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      //     tooltipMsg    : "Dashboard",
      // },

      {
        key: "kibot_chart",
        label: "menu.kibotChart",
        icon: Chart,
        activeIcon: ChartActive,
        route: "",
        foldMenuRoute: "",
        subMenu: [
          {
            key: "dashboard",
            label: "strategy.dashboard",
            icon: DashboardActive,
            activeIcon: DashboardActive,
            route: "/kibot/dashboard",
            beta: true,
            isActive: false,
          },
          {
            key: "explorer",
            label: "strategy.menu.explorer",
            icon: Explorer,
            activeIcon: Explorer,
            route: "/kibot/explorer",
            beta: true,
            isActive: false,
          },
          {
            key: "kibotZoneList",
            label: "chart2.chart",
            icon: Meta,
            activeIcon: Meta,
            route: "/kibot/kibot-zone-list",
            beta: true,
            isActive: false,
          },
          {
            key: "crossList",
            label: "strategy.menu.crossList",
            icon: Score,
            activeIcon: Score,
            route: "/kibot/cross-list",
            beta: true,
            isActive: false,
          },
          // {
          //   key: "doubleList",
          //   label: "strategy.menu.doubleList",
          //   icon: TradingView,
          //   activeIcon: TradingView,
          //   route: "/kibot/double-list",
          //   beta: true,
          //   isActive: false,
          // },
          {
            key: "favorites",
            label: "strategy.menu.favorites",
            icon: Favorites,
            activeIcon: Favorites,
            route: "/kibot/favorites",
            beta: true,
            isActive: false,
          },
          // {
          //   key: "dominance",
          //   label: "menu-dropdown.dominance",
          //   icon: Dominance,
          //   activeIcon: Dominance,
          //   route: "/kibot/chart2",
          //   beta: true,
          //   isActive: false,
          // },

          // {
          //   key: "coin_list",
          //   label: "menu-dropdown.coinList",
          //   icon: CoinList,
          //   activeIcon: CoinList,
          //   route: "/kibot/chart2",
          //   beta: true,
          //   isActive: false,
          // },
          // {
          //   key: "bubble",
          //   label: "menu-dropdown.bubble",
          //   icon: Bubble,
          //   activeIcon: Bubble,
          //   route: "/kibot/chart2",
          //   beta: true,
          //   isActive: false,
          // },
          // { key : "cue",          label : "Cue",         icon  : Cue,         activeIcon : Cue,         route : "/kibot/chart",  beta  : true,  isActive: false },
          // {
          //   key: "after",
          //   label: "menu-dropdown.after",
          //   icon: After,
          //   activeIcon: After,
          //   route: "/kibot/chart2",
          //   beta: true,
          //   isActive: false,
          // },
          // {
          //   key: "meta",
          //   label: "menu-dropdown.meta",
          //   icon: Meta,
          //   activeIcon: Meta,
          //   route: "/kibot/chart",
          //   beta: true,
          //   isActive: false,
          // },
          // {
          //   key: "score",
          //   label: "menu-dropdown.score",
          //   icon: Score,
          //   activeIcon: Score,
          //   route: "/kibot/chart",
          //   beta: true,
          //   isActive: false,
          // },
          // {
          //   key: "trading_view",
          //   label: "menu-dropdown.tradingView",
          //   icon: TradingView,
          //   activeIcon: TradingView,
          //   route: "/kibot/chart",
          //   beta: true,
          //   isActive: false,
          // },
          // { key : "alarm",        label : "Alarm",       icon  : Alarm,       activeIcon : Alarm,       route : "/kibot/alarm",  beta  : false,  isActive: false },
        ],
        // subMenuBeta   : true,
        subMenuBeta: setEnv(),
        subMenuToggle: false,
        depth: 1,
        // hasSubmenu    : true,
        hasSubmenu: setEnv(),
        showHr: false,
        // beta          : true,
        beta: setEnv(),
        isPopup: false,
        isActive: false,
        useHeader: false,
        isLogin: true,
        hasMail: false,
      },
      // {
      //   key: "kibot_auto",
      //   label: "menu.autoBot",
      //   icon: Auto,
      //   activeIcon: AutoActive,
      //   route: "",
      //   foldMenuRoute: "",
      //   subMenu: [
      //     {
      //       key: "position_bot",
      //       label: "menu-dropdown.positionBot",
      //       icon: Position,
      //       activeIcon: PositionActive,
      //       route: "/kibot/bot/position",
      //       beta: true,
      //       isActive: false,
      //     },
      //     // {
      //     //   key: "grid_bot",
      //     //   label: "menu-dropdown.gridBot",
      //     //   icon: Grid,
      //     //   activeIcon: GridActive,
      //     //   route: "/kibot/bot/grid",
      //     //   beta: true,
      //     //   isActive: false,
      //     // },
      //     // { key : "full_auto_bot",    label : "Full Auto Bot",   icon  : FullAuto,   activeIcon : FullAuto,   route : "/kibot/bot", beta  : false,  isActive: false },
      //     // { key : "dca_bot",       label : "DCA Bot",      icon  : Dca,      activeIcon : Dca,      route : "/kibot/bot", beta  : false,  isActive: false },
      //   ],
      //   subMenuBeta: true,
      //   subMenuToggle: false,
      //   depth: 1,
      //   hasSubmenu: true,
      //   showHr: false,
      //   beta: true,
      //   isPopup: false,
      //   isActive: false,
      //   useHeader: false,
      //   isLogin: true,
      //   hasMail: false,
      // },
      {
        key: "demo_trading",
        label: "trading.title.01",
        icon: Demo,
        activeIcon: DemoActive,
        route: "/trading",
        foldMenuRoute: "/trading",
        subMenu: [],
        subMenuToggle: false,
        depth: 0,
        hasSubmenu: false,
        showHr: true,
        beta: true,
        isPopup: true,
        isActive: false,
        useHeader: false,
        isLogin: true,
        hasMail: false,
      },
      // {
      //     key           : "wallet",
      //     label         : "My Wallet",
      //     icon          : Wallet,
      //     activeIcon    : WalletActive,
      //     route         : "/wallet",
      //     foldMenuRoute : "/wallet",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "daily_info",
      //     label         : "Daily Info",
      //     icon          : DailyInfo,
      //     activeIcon    : DailyInfoActive,
      //     route         : "",
      //     foldMenuRoute : "",
      //     subMenu       : [
      //         { key : 'daily_briefing', label : "Daily Briefing", icon : DailyBriefing, activeIcon : DailyBriefingActive, route : "/dailyinfo/briefing",  beta  : true },
      //         { key : 'kibot_pick',     label : "Kibot's Pick",   icon : Pick,          activeIcon : PickActive,          route : "/dailyinfo/pick",      beta  : true },
      //         { key : 'feed',           label : "Feed",           icon : Feed,          activeIcon : FeedActive,          route : "/dailyinfo/feed",      beta  : true },
      //     ],
      //     subMenuToggle : false,
      //     depth         : 1,
      //     hasSubmenu    : true,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "invite_friends",
      //     label         : "Invite Friends",
      //     icon          : Invite,
      //     activeIcon    : InviteActive,
      //     route         : "/invite_friends",
      //     foldMenuRoute : "",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "price",
      //     label         : "Price",
      //     icon          : Price,
      //     activeIcon    : PriceActive,
      //     route         : "",
      //     foldMenuRoute : "",
      //     subMenu       : [
      //         { key : 'price_kibot_auto',  label : "Kibot Auto",  icon : Auto,  activeIcon : AutoActive,  route : "",  beta  : false },
      //         { key : 'price_kibot_chart', label : "Kibot Chart", icon : Chart, activeIcon : ChartActive, route : "/price/chart",  beta  : true  },
      //     ],
      //     subMenuToggle : false,
      //     depth         : 1,
      //     hasSubmenu    : true,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "profit_status",
      //     label         : "Profit Status",
      //     icon          : Profit,
      //     activeIcon    : ProfitActive,
      //     route         : "",
      //     foldMenuRoute : "",
      //     subMenu       : [
      //         { key : 'roi',           label : "ROI",           icon : ROI,    activeIcon : ROIActive,    route : "/profit_status/kibots_roi",            beta  : true },
      //         { key : 'profit_status', label : "Profit Status", icon : Status, activeIcon : StatusActive, route : "/profit_status/kibots_profit_status",  beta  : true },
      //     ],
      //     subMenuToggle : false,
      //     depth         : 1,
      //     hasSubmenu    : true,
      //     showHr        : true,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "partnership",
      //     label         : "Partnership",
      //     icon          : Partnership,
      //     activeIcon    : PartnershipActive,
      //     route         : "/partnership",
      //     foldMenuRoute : "/partnership",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : false,
      //     beta          : false,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "about",
      //     label         : "About",
      //     icon          : About,
      //     activeIcon    : AboutActive,
      //     route         : "",
      //     foldMenuRoute : "/aboutus",
      //     subMenu       : [
      //         { key : 'about_us',    label : "About Us",    icon : AboutUs,    activeIcon : AboutUsActive,    route : "/about/aboutus",     beta  : true, isActive: false },
      //         { key : 'brand_story', label : "Brand Story", icon : BrandStory, activeIcon : BrandStoryActive, route : "/about/brandstory",  beta  : true, isActive: false },
      //         { key : 'media',       label : "Media",       icon : Media,      activeIcon : MediaActive,      route : "/about/media",       beta  : true, isActive: false },
      //         { key : 'notice',      label : "Notice",      icon : Notice,     activeIcon : NoticeActive,     route : "/about/notice",      beta  : true, isActive: false },
      //     ],
      //     subMenuToggle : false,
      //     depth         : 1,
      //     hasSubmenu    : true,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "event",
      //     label         : "Event",
      //     icon          : Event,
      //     activeIcon    : EventActive,
      //     route         : "/event",
      //     foldMenuRoute : "",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : true,
      //     beta          : false,
      //     isPopup       : false,
      //     isActive      : false,
      //     useHeader     : false,
      //     isLogin       : true,
      //     hasMail       : false,
      // },
      // {
      //     key           : "support",
      //     label         : "Support@risingx.io",
      //     icon          : Support,
      //     activeIcon    : SupportActive,
      //     route         : "",
      //     foldMenuRoute : "",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : false,
      //     isActive      : false,
      //     isLogin       : true,
      //     class         : 'size__down',
      //     hasMail       : true,
      // },
      // {
      //     key           : "inquriy",
      //     label         : "1:1 Inquiry",
      //     icon          : Inquiry,
      //     activeIcon    : Inquiry,
      //     route         : "",
      //     foldMenuRoute : "",
      //     subMenu       : [],
      //     subMenuToggle : false,
      //     depth         : 0,
      //     hasSubmenu    : false,
      //     showHr        : false,
      //     beta          : true,
      //     isPopup       : true,
      //     isActive      : false,
      //     isLogin       : true,
      //     class         : "size__down color__main",
      //     hasMail       : false,
      // },
      {
        key: "store",
        icon: Store,
        activeIcon: StoreActive,
        changeIcon: Dashboard,
        changeActiveIcon: DashboardActive,
        route: "/mystore",
        foldMenuRoute: "",
        subMenu: [],
        subMenuToggle: false,
        depth: 0,
        hasSubmenu: false,
        showHr: false,
        beta: true,
        isPopup: false,
        isActive: true,
        useHeader: true,
        isLogin: true,
        isStore: true,
        tooltipMsg: "Dashboard",
      },
      {
        key: "settings",
        icon: Settings,
        activeIcon: SettingsActive,
        route: "/settings/dashboard",
        foldMenuRoute: "",
        subMenu: [],
        subMenuToggle: false,
        depth: 0,
        hasSubmenu: false,
        showHr: false,
        beta: true,
        isPopup: false,
        isActive: false,
        useHeader: true,
        isLogin: true,
        isStore: false,
        tooltipMsg: "Setting",
      },
      {
        key: "mode",
        icon: Mode,
        activeIcon: ModeActive,
        route: "",
        foldMenuRoute: "",
        subMenu: [],
        subMenuToggle: false,
        depth: 0,
        hasSubmenu: false,
        showHr: false,
        beta: false,
        isPopup: false,
        isActive: false,
        useHeader: true,
        isLogin: true,
        isStore: false,
        tooltipMsg: "Theme",
      },
    ],
  }),
  mutations: {
    setMenuStatus(state, menuName) {
      state.menuList.forEach((item) => {
        if (item.key !== "store") {
          item.isActive = false;
        }

        if (item.key === menuName) {
          item.isActive = true;
        }

        item.subMenu.forEach((item2) => {
          item2.isActive = false;
          if (item2.key === menuName) {
            item.isActive = true;
            item2.isActive = true;
          }
        });
      });
    },
    setMenuSubItems(state, { menuIndex, filteredSubMenu }) {
      state.menuList[menuIndex].subMenu = filteredSubMenu;
      // console.log(
      //   "state.menuList[menuIndex].subMenu",
      //   state.menuList[menuIndex].subMenu
      // );
      // console.log("state.menuList", state.menuList);
    },
    resetMenuItems(state) {
      state.menuList = [...state.menuList];
    },
  },
  actions: {
    setMenuStatus({ commit }, menuName) {
      commit("setMenuStatus", menuName);
    },
    async updateMenuSubItems({ state, commit, rootState }) {
      let user_subsc_type = rootState.userInfo.chartInfo.subsc_type;
      //   console.log("user_subsc_type", user_subsc_type);

      let menuIndex = state.menuList.findIndex(
        (menu) => menu.key === "kibot_chart"
      );

      if (menuIndex !== -1 && state.menuList[menuIndex].subMenu) {
        let filteredSubMenu = state.menuList[menuIndex].subMenu;

        if (user_subsc_type === "plan99") {
          filteredSubMenu = filteredSubMenu.filter(
            (el) =>
              el.key !== "bubble" && el.key !== "after" && el.key !== "score"
          );
        }

        // 상태를 mutation을 통해 업데이트
        await commit("setMenuSubItems", { menuIndex, filteredSubMenu });
      }
    },
    // setMenuStatus(state,menuName) {
    //     state.menuList.forEach(item => {
    //         if(item.key != 'store') {
    //             item.isActive = false;
    //         }

    //         if(item.key === menuName) {
    //             item.isActive = true;
    //         }

    //         item.subMenu.forEach(item2 => {
    //             item2.isActive = false;
    //             if(item2.key === menuName) {
    //                 item.isActive = true;
    //                 item2.isActive = true;
    //             }
    //         });
    //     });
    // },
    resetMenuList() {
      this.menuList.forEach((item) => {
        item.isActive = false;
        item.subMenu.forEach((item2) => {
          item2.isActive = false;
        });
      });
    },
    setFoldStauts(fold) {
      return (this.isFold = fold);
    },
    setStoreMenu(val) {
      this.menuList.forEach((item) => {
        if (item.key === "store") {
          item.isActive = val;
        }
      });
    },
  },
  getters: {
    // mainMenuItems(state, getters, rootState) {
    //   // 사용자의 구독 유형을 가져옴
    //   let user_subsc_type = rootState.userInfo.chartInfo.subsc_type;
    //   console.log("user_subsc_type", user_subsc_type);
    //   // 메뉴에서 "kibot_chart" 키를 가진 메뉴 항목의 인덱스를 찾음
    //   let menuIndex = state.menuList.findIndex(
    //     (menu) => menu.key === "kibot_chart"
    //   );

    //   // "kibot_chart"가 존재하고 해당 인덱스를 찾았을 때
    //   if (menuIndex !== -1 && state.menuList[menuIndex].subMenu) {
    //     // 구독 유형이 "plan99"일 때, 특정 subMenu 항목 제거
    //     if (user_subsc_type === "plan99") {
    //       state.menuList[menuIndex].subMenu = state.menuList[
    //         menuIndex
    //       ].subMenu.filter(
    //         (el) =>
    //           el.key !== "bubble" && el.key !== "after" && el.key !== "score"
    //       );
    //     }
    //   }
    //   // useHeader가 false인 항목들만 필터링하여 반환
    //   return state.menuList.filter((ob) => !ob.useHeader);
    // },
    mainMenuItems(state) {
      //   console.log("mainMenuItems");
      return state.menuList.filter((ob) => !ob.useHeader);
    },
    settingItems(state) {
      return state.menuList.filter((ob) => ob.useHeader);
    },
    sideIsFold(state) {
      return state.isFold;
    },
    chartMenuItems(state) {
      const fi = state.menuList.findIndex((item) => item.key === "kibot_chart");
      return state.menuList[fi].subMenu.filter(
        (ob) => ob.route === "/kibot/chart" && ob.beta
      );
    },
  },
};
